module.exports = __webpack_public_path__ + "static/img/green-sphere-120.beb273b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/green-sphere-120.png
// module id = popA
// module chunks = 1